import {
  IGetPromoDetailParams,
  IPromoDetail,
  IPromoDetailRepository,
} from "@/core/repositories/promotion/IPromoDetail.repository";

export class GetPromoDetailUseCase {
  constructor(private readonly repo: IPromoDetailRepository) {}

  async execute(params: IGetPromoDetailParams, refetch = false): Promise<IPromoDetail> {
    return this.repo.getPromoDetail(params, refetch);
  }
}
